import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { ClientSearchComponent } from './client-search.component';

@NgModule({
    declarations: [ClientSearchComponent],
    imports: [
        CommonModule,
        FormsModule,
        OverlayModule
    ],
    exports: [ClientSearchComponent]
})
export class ClientSearchModule {}
